import React, { useEffect, useRef, useMemo } from "react";

import JsBarcode from "jsbarcode";

const ThermalPriceTagLabel = ({ data }) => {
  const barcodeRefs = useRef([]);

  const barcodeOptions = useMemo(
    () => ({
      format: "CODE128",
      lineColor: "#000000",
      width: 1.5, // Optimal thickness for scanning
      height: 40, // Reduced height for portrait layout
      displayValue: true,
      fontSize: 8,
      margin: 2,
      fontOptions: "bold",
    }),
    [],
  );
  const lowestPrice = useMemo(() => {
    if (!data?.variants?.length) return null;

    return Math.min(
      ...data.variants.map((v) => Number(v.price)).filter((p) => !isNaN(p)),
    );
  }, [data?.variants]);
  const expandedVariants = useMemo(() => {
    if (!data?.variants) return [];

    return data.variants.flatMap((variant) => {
      const quantity = Math.max(0, parseInt(variant.bar_quantity) || 0);
      return Array.from({ length: quantity }, (_, i) => ({
        ...variant,
        product_title: data.title || data.product_title || "Product",
        uniqueKey: `${variant.id}-${i}`,
        sequence: i + 1,
      }));
    });
  }, [data]);

  useEffect(() => {
    barcodeRefs.current.forEach((ref, index) => {
      try {
        if (ref && expandedVariants[index]?.barcode) {
          JsBarcode(ref, expandedVariants[index].barcode, barcodeOptions);
        }
      } catch (error) {
        console.error("Barcode generation error:", error);
      }
    });
  }, [expandedVariants, barcodeOptions]);

  return (
    <div
      className="portrait-labels"
      style={{
        width: "42mm",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>{`
        @page {
          size: 42mm 64mm;
          margin: 0;
        }
        body {
          margin: 0 !important;
          padding: 0 !important;

        }
         .label {
           width: 100%;
  height: 64mm;
  box-sizing: border-box;

//border: 1px dashed blue;
  page-break-after: always;
  break-after: page;
  position: relative; 
    display: flex;
  flex-direction: column;
justify-content: center;
  align-items: center;  
padding-top: 4mm;
  padding-left: 1mm;
        }
        .text-content {
        
 display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
        }

        .product-name {
      
          font-size: 10pt;
          font-weight: bold;
          line-height: 1;
          margin-bottom: 0.5mm;
          text-transform: uppercase;
        
        
        }
       
          .sku {
          font-size:9pt;
          font-family: 'Courier New', monospace;
     margin-bottom: 0.5mm;
        
        }
        .variant-title {
          font-size: 11pt;
          font-weight: bold;
        
        }
        .variant-price {
          font-size: 11pt;
          font-weight: bold;

        }
        .barcode-container {
        margin-left: 1mm;
          width: 100%;
          height: 20mm;
          display: flex;
          justify-content: center;
          align-items: center;

    
        }
   .barcode-container svg {
  display: block;
  margin: 0 auto;
}
        .footer-container {
      // position: absolute;
      bottom: 0mm;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      width: 100%;
        }
        .website {
          text-align: center;
          font-size: 6pt;
          font-weight: bold;
          margin-top: 1mm;
          border-top: 0.5px solid #000;
          padding-top: 0.5mm;
        }
        
      }
      
      `}</style>

      {expandedVariants.map((variant, index) => (
        <div key={variant.uniqueKey} className="label p3">
          <div className="text-content">
            <div className="product-name p3">{variant.product_title}</div>

            <div className="variant-title p3">Size {variant.title}</div>

            <div className="sku">{variant.sku}</div>
          </div>

          <div className="barcode-container">
            <svg
              ref={(el) => (barcodeRefs.current[index] = el)}
              aria-label={`Barcode for ${variant.sku}`}
            />
          </div>
          <div className="variant-price">
            <p> M.S.R.P : PKR {lowestPrice?.toLocaleString()}.00</p>
          </div>
          <div className="website">
            <p className="web-small">www.velvourshop.com</p>
          </div>
        </div>
      ))}
    </div>
  );
};
export default ThermalPriceTagLabel;
